/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import React from "react";
import { Link } from "react-router-dom";

export const SalesDashboardPermissionError: React.FC = () => (
  <main css={styles.page}>
    <section css={styles.panel} role="alert">
      <div css={styles.iconCircle}>
        <LockOutlinedIcon aria-hidden="true" css={styles.icon} />
      </div>

      {/* eslint-disable-next-line no-restricted-syntax -- i18n 未対応 */}
      <h1 css={styles.title}>このページへのアクセス権限がありません</h1>

      <div css={styles.description}>
        {/* eslint-disable-next-line no-restricted-syntax -- i18n 未対応 */}
        <p>
          ダッシュボードの閲覧には権限が必要です。
          {/* eslint-disable-next-line no-restricted-syntax -- i18n 未対応 */}
          <br />
          権限付与されたアカウントでログインしているかご確認ください。
        </p>
        {/* eslint-disable-next-line no-restricted-syntax -- i18n 未対応 */}
        <p>権限が必要な場合は、管理者までお問い合わせください。</p>
      </div>

      {/* eslint-disable-next-line no-restricted-syntax -- i18n 未対応 */}
      <Link css={styles.homeLink} to="/">
        ホームに戻る
      </Link>
    </section>
  </main>
);

const styles = {
  page: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: calc(100vh - 65px - 179px);
    padding: clamp(40px, 8vh, 96px) 20px;
    background: #131c26;
    @supports (min-height: 100dvh) {
      min-height: calc(100dvh - 65px - 179px);
    }
  `,
  panel: css`
    width: min(100%, 560px);
    padding: clamp(32px, 5vw, 52px);
    text-align: center;
    background: #1b2734;
    border: 1px solid #2e3d4c;
    border-radius: 14px;
    box-shadow: 0 8px 32px rgb(0 0 0 / 35%);
  `,
  iconCircle: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 76px;
    height: 76px;
    margin: 0 auto 26px;
    background: rgb(214 164 95 / 16%);
    border-radius: 50%;
  `,
  icon: css`
    &.MuiSvgIcon-root {
      width: 38px;
      height: 38px;
      color: #d6a45f;
    }
  `,
  title: css`
    margin: 0 0 14px;
    color: #ffffff;
    font-size: clamp(22px, 3vw, 26px);
    font-weight: 700;
    letter-spacing: 0.01em;
    line-height: 1.45;
  `,
  description: css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 0 0 30px;
    color: #b9c3cd;
    font-size: 15px;
    p {
      line-height: 1.75;
    }
  `,
  homeLink: css`
    display: block;
    width: min(100%, 320px);
    padding: 13px 20px;
    margin: 0 auto;
    color: #06231f;
    font-size: 15px;
    font-weight: 700;
    text-align: center;
    text-decoration: none;
    background: #00c2ae;
    border-radius: 9px;
    transition: background-color 0.2s ease;
    &:hover {
      color: #06231f;
      background: #33d6c4;
    }
    &:focus-visible {
      outline: 2px solid #ffffff;
      outline-offset: 3px;
    }
  `,
};
